import "./UnitFavAction.scss"
import React from "react";
import {IconHeart} from "../../icons";
import {useLocalStorage} from "usehooks-ts";
import {IconHeartFill} from "../../icons/icon-heart-fill";

export interface IUnitFavActionProps {
  unitGroupId: number
}

export function UnitFavAction(p: IUnitFavActionProps) {

  const [lsFloor] = useLocalStorage<number>("storefront-floor-selector-" + p.unitGroupId, 0)
  const [lsFavorites, setLsFavorites] = useLocalStorage<number[]>("storefront-favorites", [])

  const checked = lsFavorites.findIndex(f => f == p.unitGroupId) >= 0;

  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    const f = lsFavorites.find(f => f == p.unitGroupId)
    if(!f) {
      lsFavorites.push(p.unitGroupId)
    } else {
      lsFavorites.splice(lsFavorites.indexOf(f), 1)
    }
    setLsFavorites([...lsFavorites])
    return false
  }

  return <div className="UnitFavAction">
    <a href="#" onClick={onClick}>
      {checked?<IconHeartFill/>:<IconHeart/>}
    </a>
  </div>
}